// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"1e3f0a2a","297":"6d454af5","458":"5510dffa","643":"3c7e2d50","787":"59347856"}[chunkId] + ".chunk.js";
};